import type { BffApiClient } from "@/app/api-client"
import type { Blockchain } from "@anaconda/core/blockchain/types"
import { DropStatus } from "@anaconda/core/drop/types"
import { z } from "zod"

export const SEARCH_PARAMS_SCHEMA = z.object({
  size: z.number().int().positive().default(50),
  status: z
    .union([
      z.enum([DropStatus.Upcoming, DropStatus.Minting, DropStatus.Ended]),
      z.array(
        z.enum([DropStatus.Upcoming, DropStatus.Minting, DropStatus.Ended]),
      ),
    ])
    .optional(),
})

export function getStateFromSearchParams(
  params: z.infer<typeof SEARCH_PARAMS_SCHEMA>,
) {
  return {
    size: params.size,
    status: params.status,
  }
}

export function getDropsQueryParams(
  apiClient: BffApiClient,
  params: {
    size: number
    status?: DropStatus | DropStatus[]
    blockchains: Blockchain[]
  },
) {
  return {
    queryKey: ["drops", "search", params],
    queryFn: async () => {
      const response = await apiClient.api.drops.search.$post(
        { json: params },
        {
          init: {
            next: {
              revalidate: 20,
            },
          },
        },
      )

      if (!response.ok) throw await response.json()

      return response.json()
    },
  }
}
